import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

const SERIF = "'Newsreader', Georgia, serif";
const SANS  = "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif";
const NAVY  = '#16304a';
const TEAL  = '#1d6f6a';
const BEIGE = '#f6efe2';
const SELF  = '/coverage/workforce-labor';

function SponsoredBand() {
  return (
    <div style={{ background: BEIGE, marginTop: 34, borderTop: '1px solid #e7ddc9' }} data-testid="wl-sponsored-band">
      <div className="container-custom">
        <div style={{ padding: '22px 0' }}>
          <div style={{ fontWeight: 700, fontSize: 9.5, letterSpacing: '1.4px', textTransform: 'uppercase', color: '#a8967a', marginBottom: 10 }}>Sponsored Content</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 0', minWidth: 260 }}>
              <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 26, lineHeight: 1.1, margin: '0 0 6px', color: NAVY }}>Invest in People. Build the Future.</h2>
              <p style={{ fontSize: 13, color: '#6c6258', margin: '0 0 9px', maxWidth: 420 }}>Discover how leading companies are creating opportunity through training, innovation, and inclusive hiring.</p>
              <Link to={SELF} style={{ color: NAVY, fontWeight: 600, fontSize: 13, textDecoration: 'none' }}>Explore Briefings&nbsp;→</Link>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 28, flexWrap: 'wrap' }}>
              {[
                { label: 'Career Growth Opportunities', icon: <svg width="34" height="34" viewBox="0 0 36 36" fill="none" stroke={TEAL} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="12" r="6"/><path d="M8 30c0-6 4.5-10 10-10s10 4 10 10"/><polyline points="22,10 26,6 30,10"/></svg> },
                { label: 'Tuition Assistance & Training', icon: <svg width="34" height="34" viewBox="0 0 36 36" fill="none" stroke={TEAL} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M18 4l12 6v8c0 7-5 13-12 15C11 31 6 25 6 18v-8z"/><path d="M13 17l3.5 3.5 7-7"/></svg> },
                { label: 'Competitive Pay & Benefits', icon: <svg width="34" height="34" viewBox="0 0 36 36" fill="none" stroke={TEAL} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="18" r="14"/><path d="M18 10v8M18 10v8l5 3"/></svg> },
              ].map((item) => (
                <div key={item.label} style={{ textAlign: 'center' }}>
                  <div style={{ display: 'block', margin: '0 auto 6px' }}>{item.icon}</div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: NAVY, textAlign: 'center', maxWidth: 76, lineHeight: 1.3 }}>{item.label}</div>
                </div>
              ))}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, paddingLeft: 20, borderLeft: '1px solid #d8cdb5' }}>
                <span style={{ fontSize: 28, fontWeight: 700, color: '#2164f3', letterSpacing: '-0.5px', fontFamily: SANS, lineHeight: 1 }}>indeed</span>
                <span style={{ fontSize: 10, color: '#6c6258', letterSpacing: '0.2px' }}>The world works here.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const WORKFORCE_LABOR_CONFIG = {
  slug: 'workforce-labor',
  label: 'Workforce & Labor',
  selfPath: SELF,
  heroSlug: 'coverage/workforce-labor',
  h1Text: 'Workforce & Labor',
  h1Subtitle: 'Jobs. Skills. Apprenticeships. Labor trends. Wages. Employers. Opportunity for all.',
  h1Body: 'Independent reporting and smart analysis on the people, policies, and innovations shaping work — and driving economic opportunity.',
  briefingCtaText: "Read Today's Workforce Briefing",
  storiesCtaText: 'Explore Workforce & Labor Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Workforce & Labor Briefings',
  testId: 'workforce-labor-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:15', title: 'The Power of Apprenticeships in America', description: 'How registered apprenticeships lead to higher wages and long-term career success.' },
    { type: 'in_focus', label: 'Employer Spotlight', name: 'Caterpillar Inc.', description: 'Building the future through innovation, inclusion, and workforce development.', badgeInitials: 'CAT', badgeBg: '#000', badgeColor: '#f0c000' },
    { type: 'executive_spotlight', initials: 'MP', name: 'Monica Proctor', title: 'Chief People Officer, Caterpillar Inc.', description: "On building talent pipelines and preparing people for tomorrow's jobs." },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

export default function WorkforceLaborPage() {
  return (
    <SectorPage
      config={WORKFORCE_LABOR_CONFIG}
      PulseBar={() => <Ticker scope="workforce-labor" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
